export default {
    /*
     * container must be set (vuex store)
     * usually in main.js
     */
    container: null,
    sendRequest: function(method, path, data, callback) {
        let that = this;
        let http = new XMLHttpRequest();
        http.open(method, this.container.state.api_url+path, true);
        http.setRequestHeader('Accept', 'application/json');
        http.setRequestHeader('X-API-TOKEN', this.container.state.api_token);
        if (null == data){
            http.send(null);
        } else {
            http.send(JSON.stringify(data));
        }
        http.onreadystatechange = function(){
            if (4 == http.readyState) {
                if (200 <= http.status && 300 > http.status) {
                    try {
                        callback(JSON.parse(http.responseText), null)
                    }
                    catch(err) {
                        callback(null, err.message);
                    }
                } else {
                    if ('' != http.responseText) {
                        callback(null, http.responseText)
                    } else {
                        callback(null, http.statusText)
                    }
                }
            }
        }
    },
    

}

